<template>
	<div>
		<action-sidebar
			title="Importar Centro de Costos"
			:value="true"
			:width="450"
			@close-modal="closeModal"
		>
			<cost-center-import
				@on-close="closeModal"/>
		</action-sidebar>
	</div>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import costCenterImport from '@/components/cost-centers/cost-center-import';
	import { COSTS_CENTERS } from '@/shared/action-codes';

	
	function closeModal() {
		this.goTo(COSTS_CENTERS, { query: this.$route.query });
	}

	export default {
		name: 'page-cost-center-import',
		components: {
			actionSidebar,
			costCenterImport,
		},
		methods: {
			closeModal,
		},
		props: {
			id: [Number, String],
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/cost-centers/page-cost-center-import.vue